import { gql } from '@apollo/client'

import { FRONTEND_URL } from '../constants'

export const INVITE_SUBJECT = `Create your TMC Account!`

export const GET_INVITES = gql`
  query GetInvites {
    invites(first: 1000) {
      edges {
        node {
          email
          role
        }
      }
    }
  }
`

export function generateInviteBody() {
  const copyrightYear = new Date().getFullYear()
  const body = `
  <table
  style="max-width: 600px; margin: 0px auto"
  border="0"
  width="90%"
  cellspacing="0"
  cellpadding="0"
>
  <tbody>
    <tr>
      <td
        style="padding: 33px 0px 18px 0px"
        colspan="3"
        align="center"
        valign="top"
      >
        <img
          src="https://smartfirm-tmc-assets.s3.amazonaws.com/email/EmailBanner_vTMC-01.jpg"
          alt="TMC banner"
          width="600"
          height="auto"
          border="0"
        />
      </td>
    </tr>
    <tr>
      <td
        style="
          padding: 0px 0px 18px 0px;
          color: #333333;
          font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
          font-size: 17px;
          font-weight: 700;
          line-height: 25px;
          margin: 0;
          text-align: left;
        "
        align="center"
        valign="top"
      >
        Welcome to The Manager Challenge (TMC)!
      </td>
    </tr>
    <tr>
      <td
        style="
          padding: 0px 0px 18px 0px;
          color: #333333;
          font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
          font-size: 17px;
          font-weight: 400;
          line-height: 25px;
          margin: 0;
          text-align: left;
        "
        align="center"
        valign="top"
      >
      At this point, you should have received a welcome email from the Learning & Development team with an overview of the program. If you have any questions on this information or if you didn’t receive it, please reach out to <a href="mailto:training@protiviti.com">training@protiviti.com</a>.
      </td>
    </tr>
    <tr>
      <td
        style="
          padding: 0px 0px 18px 0px;
          color: #333333;
          font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
          font-size: 17px;
          font-weight: 700;
          line-height: 25px;
          margin: 0;
          text-align: left;
        "
        align="center"
        valign="top"
      >
        Create your TMC Website Account.
      </td>
    </tr>
    <tr>
      <td
        style="
          padding: 0px 0px 18px 0px;
          color: #333333;
          font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
          font-size: 17px;
          font-weight: 400;
          line-height: 25px;
          margin: 0;
          text-align: left;
        "
        align="center"
        valign="top"
      >
       The first step of your learning journey is to create an account on the TMC website. This site will be used as the central “hub” throughout the program - where you will complete required learning activities, access class materials, and earn points to climb the TMC leaderboard.
      </td>
    </tr>
    <tr>
      <td
        style="
          padding: 0px 0px 18px 0px;
          color: #333333;
          font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
          font-size: 17px;
          font-weight: 400;
          line-height: 25px;
          margin: 0;
          text-align: left;
        "
        align="center"
        valign="top"
      >
        Click the button below to create your account and get started. Once your account is created, you will receive a confirmation email with next steps. If you experience any issues setting up your account, please reach out to <a href="mailto:training@protiviti.com">training@protiviti.com</a>.
      </td>
    </tr>
    <tr>
      <td style="padding: 12px 0px 36px 0px" align="center" valign="top">
        <table
          style="margin: 0 auto"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <tbody>
            <tr>
              <td
                style="border-radius: 4px"
                align="center"
                bgcolor="#d74b29"
                width="315"
              >
                <a
                  style="
                    padding: 18px;
                    display: block;
                    text-decoration: none;
                    border: 1px solid #d74b29;
                    text-align: center;
                    font-size: 14px;
                    font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
                    letter-spacing: 1px;
                    color: #ffffff;
                    background: #d74b29;
                    border-radius: 4px;
                    line-height: 17px;
                    text-transform: uppercase;
                    width: 315px;
                  "
                  href="${FRONTEND_URL}/register"
                  target="_blank"
                  rel="noopener"
                  >Create Account
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td
        style="
          padding: 24px 0px 18px 0px;
          color: #787676;
          font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
          font-size: 13px;
          font-weight: 400;
          line-height: 19px;
          margin: 0;
        "
        colspan="3"
        align="center"
        valign="top"
      >
        © ${copyrightYear} Protiviti, All rights reserved
      </td>
    </tr>
  </tbody>
</table>
`
  return body
}

export const GET_OFFERINGS = gql`
  query GetOfferings {
    offerings {
      edges {
        node {
          offeringDate
        }
      }
    }
  }
`

export const GET_USERS = gql`
  query GetUser {
    users(first: 1000) {
      edges {
        node {
          id
          databaseId
          firstName
          lastName
          email
          points
          capabilities
          completion
          profilePic
          transactions {
            bonus
            operation
            timestamp
            updaterId
            userId
          }
        }
      }
    }
  }
`

export const GET_POINTS_UPDATE_TRANSACTION_REPORT = gql`
  query PointUpdateTransactionReport {
    pointUpdateTransactionReport {
      bonus
      operation
      pointsAfter
      timestamp
      updaterId
      userId
    }
  }
`

export const CREATE_OFFERING_MUTATION = gql`
  mutation CreateOffering($clientMutationId: String, $offeringDate: String!) {
    createOffering(
      input: {
        clientMutationId: $clientMutationId
        offeringDate: $offeringDate
        status: PUBLISH
      }
    ) {
      offering {
        id
        databaseId
      }
    }
  }
`

export const CREATE_BULK_INVITE_MUTATION = gql`
  mutation CreateBulkInvite(
    $clientMutationId: String
    $invites: [InviteInputType]!
  ) {
    createBulkInvite(
      input: { clientMutationId: $clientMutationId, invites: $invites }
    ) {
      emails
    }
  }
`

export const SEND_INVITE_EMAIL_MUTATION = gql`
  mutation SendInviteEmail($to: String!, $subject: String!, $body: String!) {
    sendEmail(input: { to: $to, subject: $subject, body: $body }) {
      origin
      sent
      message
    }
  }
`

export const RESET_OFFERING_MUTATION = gql`
  mutation ResetOffering($id: ID!) {
    resetOffering(input: { id: $id }) {
      id
    }
  }
`

export const UPDATE_USER_ROLE = gql`
  mutation UpdateUserRole($username: String!, $role: String!) {
    updateUserRole(input: { username: $username, role: $role }) {
      username
      new_role
    }
  }
`

export const CREATE_INVITE_MUTATION = gql`
  mutation CreateInvites(
    $clientMutationId: String!
    $email: String!
    $role: String!
  ) {
    createInvite(
      input: {
        clientMutationId: $clientMutationId
        email: $email
        role: $role
        status: PUBLISH
      }
    ) {
      invite {
        id
      }
    }
  }
`

export const UPDATE_OFFERING_MUTATION = gql`
  mutation UpdateOffering(
    $clientMutationId: String
    $id: ID!
    $offeringDate: String
    $day1ContentLock: Boolean
    $day2ContentLock: Boolean
    $day3ContentLock: Boolean
    $day4ContentLock: Boolean
    $day1ReflectionPointLock: Boolean
    $day2ReflectionPointLock: Boolean
    $day3ReflectionPointLock: Boolean
    $day4ReflectionPointLock: Boolean
  ) {
    updateOffering(
      input: {
        clientMutationId: $clientMutationId
        id: $id
        offeringDate: $offeringDate
        day1ContentLock: $day1ContentLock
        day2ContentLock: $day2ContentLock
        day3ContentLock: $day3ContentLock
        day4ContentLock: $day4ContentLock
        day1ReflectionPointLock: $day1ReflectionPointLock
        day2ReflectionPointLock: $day2ReflectionPointLock
        day3ReflectionPointLock: $day3ReflectionPointLock
        day4ReflectionPointLock: $day4ReflectionPointLock
      }
    ) {
      offering {
        offeringDate
        day1ContentLock
        day2ContentLock
        day3ContentLock
        day4ContentLock
        day1ReflectionPointLock
        day2ReflectionPointLock
        day3ReflectionPointLock
        day4ReflectionPointLock
      }
    }
  }
`

export const UPDATE_AGENDA_ITEM_MUTATION = gql`
  mutation UpdateAgendaItem(
    $clientMutationId: String
    $id: ID!
    $postId: String
    $order: Int
    $lock: Boolean
    $detail: AgendaItemDetailInputType
  ) {
    updateAgendaItem(
      input: {
        clientMutationId: $clientMutationId
        id: $id
        postId: $postId
        order: $order
        lock: $lock
        detail: $detail
      }
    ) {
      agendaItem {
        order
        postId
        title
        lock
        detail {
          modules {
            title
            overview
            materialsTitle
            materials {
              name
              url
            }
          }
          knowledgeCheck {
            lock
            questions {
              id
              statement
              choices {
                id
                text
                correct
              }
              point
              gradingMethod
              feedback {
                correct
                incorrect
              }
            }
          }
        }
      }
    }
  }
`

export const UPDATE_HOME_PAGE_MUTATION = gql`
  mutation UpdateHomePage(
    $id: ID!
    $title: String
    $subtitle: String
    $overview: String
    $section1: Section1InputType
    $section2: Section2InputType
  ) {
    updateHomePage(
      input: {
        id: $id
        title: $title
        subtitle: $subtitle
        overview: $overview
        section1: $section1
        section2: $section2
      }
    ) {
      homePage {
        subtitle
        title
        overview
        section1 {
          title
          content
        }
        section2 {
          title
          subsections {
            title
            content
          }
        }
      }
    }
  }
`
export const UPDATE_AGENDA_PAGE_MUTATION = gql`
  mutation UpdateAgendaPage(
    $id: ID!
    $title: String
    $overview: String
    $instruction: String
  ) {
    updateAgendaPage(
      input: {
        id: $id
        title: $title
        overview: $overview
        instruction: $instruction
      }
    ) {
      agendaPage {
        title
        overview
        instruction
      }
    }
  }
`
export const CREATE_AGENDA_ITEM_MUTATION = gql`
  mutation CreateAgendaItem(
    $clientMutationId: String
    $order: Int
    $postId: String!
    $title: String!
    $detail: AgendaItemDetailInputType
    $status: PostStatusEnum
  ) {
    createAgendaItem(
      input: {
        clientMutationId: $clientMutationId
        postId: $postId
        order: $order
        title: $title
        detail: $detail
        status: $status
      }
    ) {
      agendaItem {
        databaseId
        postId
        order
        title
        detail {
          resources {
            name
            type
            url
          }
        }
        status
      }
    }
  }
`
export const UPDATE_TIPSTOOLS_PAGE_MUTATION = gql`
  mutation UpdateTipsToolsPage($id: ID!, $title: String, $overview: String) {
    updateTipsToolsPage(
      input: { id: $id, title: $title, overview: $overview }
    ) {
      tipsToolsPage {
        title
        overview
      }
    }
  }
`
export const CREATE_TIPSTOOLS_ITEM = gql`
  mutation CreateTipsToolsItem(
    $clientMutationId: String
    $order: Int
    $postId: String!
    $title: String!
    $detail: TipsToolsItemDetailInputType
    $status: PostStatusEnum
  ) {
    createTipsToolsItem(
      input: {
        clientMutationId: $clientMutationId
        postId: $postId
        order: $order
        title: $title
        detail: $detail
        status: $status
      }
    ) {
      tipsToolsItem {
        databaseId
        postId
        order
        title
        detail {
          resources {
            name
            type
            url
          }
        }
        status
      }
    }
  }
`
export const DELETE_TIPSTOOLS_ITEM_MUTATION = gql`
  mutation DeleteTipsToolsItem($id: ID!) {
    deleteTipsToolsItem(input: { id: $id }) {
      tipsToolsItem {
        title
      }
    }
  }
`
export const UPDATE_TIPSTOOLS_ITEM_MUTATION = gql`
  mutation UpdateTipsToolsItem(
    $id: ID!
    $title: String
    $postId: String
    $order: Int
    $detail: TipsToolsItemDetailInputType
    $status: PostStatusEnum
  ) {
    updateTipsToolsItem(
      input: {
        id: $id
        title: $title
        postId: $postId
        order: $order
        detail: $detail
        status: $status
      }
    ) {
      tipsToolsItem {
        status
        title
        postId
        order
        detail {
          resources {
            name
            type
            url
          }
        }
      }
    }
  }
`
export const UPDATE_LEARNING_LOUNGE_PAGE_MUTATION = gql`
  mutation UpdateLearningLoungePage(
    $id: ID!
    $title: String
    $overview: String
  ) {
    updateLearningLoungePage(
      input: { id: $id, title: $title, overview: $overview }
    ) {
      learningLoungePage {
        title
        overview
      }
    }
  }
`
export const CREATE_LEARNING_LOUNGE_ITEM_MUTATION = gql`
  mutation CreateLearningLoungeItem(
    $clientMutationId: String
    $required: Boolean!
    $order: Int
    $postId: String!
    $title: String!
    $duration: String
    $thumbnail: String
    $detail: LearningLoungeItemDetailInputType
    $status: PostStatusEnum
  ) {
    createLearningLoungeItem(
      input: {
        clientMutationId: $clientMutationId
        required: $required
        order: $order
        postId: $postId
        title: $title
        duration: $duration
        thumbnail: $thumbnail
        detail: $detail
        status: $status
      }
    ) {
      learningLoungeItem {
        databaseId
        required
        order
        postId
        title
        duration
        thumbnail
        detail {
          overview
          steps
          note
          resources {
            id
            type
            name
            url
          }
          questions {
            id
            statement
            choices {
              id
              text
              correct
            }
            feedback {
              correct
              incorrect
            }
            point
            gradingMethod
          }
        }
        status
      }
    }
  }
`
export const UPDATE_LEARNING_LOUNGE_ITEM_MUTATION = gql`
  mutation UpdateLearningLoungeItem(
    $id: ID!
    $order: Int
    $postId: String
    $title: String
    $required: Boolean
    $duration: String
    $thumbnail: String
    $detail: LearningLoungeItemDetailInputType
    $status: PostStatusEnum
  ) {
    updateLearningLoungeItem(
      input: {
        id: $id
        order: $order
        postId: $postId
        title: $title
        required: $required
        duration: $duration
        thumbnail: $thumbnail
        detail: $detail
        status: $status
      }
    ) {
      learningLoungeItem {
        order
        postId
        title
        required
        duration
        thumbnail
        detail {
          overview
          steps
          note
          resources {
            id
            type
            name
            url
          }
          questions {
            id
            statement
            choices {
              id
              text
              correct
            }
            feedback {
              correct
              incorrect
            }
            point
            gradingMethod
          }
        }
        status
      }
    }
  }
`
export const DELETE_LEARNING_LOUNGE_ITEM_MUTATION = gql`
  mutation DeleteLearningLoungeItem($id: ID!) {
    deleteLearningLoungeItem(input: { id: $id }) {
      learningLoungeItem {
        title
      }
    }
  }
`
export const RESTORE_POST_MUTATION = gql`
  mutation RestorePost($id: ID!) {
    restorePost(input: { id: $id }) {
      id
    }
  }
`
